module.exports = __webpack_public_path__ + "img/SMT_55_Ms_Rina_Wang_Yng_Chyi.7dbd7dd2.jpg";